<template>
  <Transition name="fade-fast">
    <div v-if="$store.state.app.ready && $store.state.auth.initiated">
      <template v-if="!mq.mdPlus">
        <SiteNav />
        <RouterView v-slot="{ Component, route }">
          <Transition :name="route?.meta?.transition || 'page-slide-left'" mode="out-in">
            <component :is="Component" :key="routeKey(route.name)" />
          </Transition>
        </RouterView>
        <Gdpr />
      </template>
      <Transition name="fade-fast">
        <DesktopWelcome v-if="mq.mdPlus" />
      </Transition>
    </div>
  </Transition>
  <Transition name="fade-fast">
    <Loader v-if="!$store.state.app.ready || !$store.state.auth.initiated" />
  </Transition>
</template>

<script>
import { DesktopWelcome } from '@/components/blocks'
import Gdpr from '@/components/gdpr/Gdpr.vue'
import { SiteNav } from '@/components/navigation'
import { Loader } from '@/components/small'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  inject: ['mq'],
  setup() {
    useLangRouter()
  },
  components: {
    DesktopWelcome,
    Gdpr,
    Loader,
    SiteNav,
  },
  data() {
    return {
      appReady: false,
    }
  },
  methods: {
    routeKey(routeName) {
      if (this.$store.state.auth.logged_in) return 'hunt-pages'
      return routeName
    },
  },
  watch: {
    '$i18n.locale': {
      handler: async function (to) {
        await this.$beet.fetchCoreData(to)
        await this.$store.dispatch('initApp', {
          clothing: this.$beet.clothing,
          clothingTypes: this.$beet.clothing_types,
        })
      },
      immediate: true,
    },
  },
  updated() {
    this.$nextTick(() => {
      const el = this.$route.hash ? document.querySelector(this.$route.hash) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    })
  },
}
</script>
